import React, { Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';

//VISTAS CLIENTE
import Category from './components/Product/Category';
import Home from './components/Product/Home';
import Products from './components/Product/Products';
import AboutUs from './components/Extras/AboutUs';
import Commentary from './components/Extras/Commentary';
import ProductDescription from './components/Product/ProductDescription';
import ShoppingCart from './components/Order/ShoppingCartComponent';

function App() {
	return (
		<Provider store={store}>
			<Router>
				<Fragment>
					<Switch>
						<Route exact path="/:pageName" component={Home} />
						<Route exact path="/:pageName/products" component={Category} />
						<Route exact path="/:pageName/products/:productName" component={Products} />
						<Route exact path="/:pageName/products/:productName/:productId" component={ProductDescription} />
						<Route exact path="/:pageName/nosotros" component={AboutUs} />
						<Route exact path="/:pageName/commentary" component={Commentary} />
						<Route exact path="/:pageName/shoppingCart" component={ShoppingCart} />
					</Switch>
				</Fragment>
			</Router>
		</Provider>
	);
}

export default App;
